import request from 'utils/Httprequest';
const prefixed = '/api/braintrain-service-photon';

/**
 * module: 获取班级的相关接口
 */
export default {
  // 班级列表
  cyClassList(data) {
    return request({
      url: `${prefixed}/workbench/class/list`,
      method: "post",
      json: true,
      data: data,
    });
  },
  // 班级列表
  ccClassList(data) {
    return request({
      url: `${prefixed}/ccStudent/relation/selectClassListByEmployeeId`,
      method: "post",
      json: true,
      data: data,
    });
  },
  ///获取cr绑定的微信群 
  getTeacherBindWechatGroup(data) {
    return request({
      url: `${prefixed}/photon/wechat/group/getTeacherBindWechatGroup`,
      method: "post",
      json: true,
      data: data,
    });
  },
  ///获取cc绑定的微信群 
  getCcBindWechatGroup(data) {
    return request({
      url: `${prefixed}/photon/wechat/group/getCcBindWechatGroup`,
      method: "post",
      json: true,
      data: data,
    });
  },
  // 关联/取消关联
  classBindWechatGroup(data) {
    return request({
      url: `${prefixed}/photon/wechat/group/bindWechatGroup`,
      method: "post",
      json: true,
      data: data,
    });
  },
  // 班级学情统计
  classStatistics(data) {
    return request({
      url: `${prefixed}/workbench/class/statistics`,
      method: "post",
      json: true,
      data: data,
    });
  },
};